/**
 * The 10-color collar palette breeders use to ID newborns. Each entry has a
 * `swatch` (Tailwind class for a tiny color chip) and a `tone` (a darker
 * variant for borders/text on light backgrounds).
 */
export const COLLAR_COLORS = [
  { key: "red",    label: "Red",    swatch: "bg-red-500",     tone: "text-red-700",     hex: "#ef4444" },
  { key: "pink",   label: "Pink",   swatch: "bg-pink-400",    tone: "text-pink-700",    hex: "#f472b6" },
  { key: "yellow", label: "Yellow", swatch: "bg-yellow-400",  tone: "text-yellow-700",  hex: "#facc15" },
  { key: "blue",   label: "Blue",   swatch: "bg-blue-500",    tone: "text-blue-700",    hex: "#3b82f6" },
  { key: "green",  label: "Green",  swatch: "bg-emerald-500", tone: "text-emerald-700", hex: "#10b981" },
  { key: "orange", label: "Orange", swatch: "bg-orange-500",  tone: "text-orange-700",  hex: "#f97316" },
  { key: "purple", label: "Purple", swatch: "bg-purple-500",  tone: "text-purple-700",  hex: "#a855f7" },
  { key: "black",  label: "Black",  swatch: "bg-slate-900",   tone: "text-slate-900",   hex: "#0f172a" },
  { key: "white",  label: "White",  swatch: "bg-white border border-border", tone: "text-slate-600", hex: "#94a3b8" },
  { key: "teal",   label: "Teal",   swatch: "bg-teal-500",    tone: "text-teal-700",    hex: "#14b8a6" },
];

export function collarFor(key) {
  return COLLAR_COLORS.find((c) => c.key === key) || null;
}
